import React, { useRef } from "react";
import PropTypes from 'prop-types';
import { Button } from "react-bootstrap";
import { isEmpty } from "lodash";

const ChartContainer = (props) => {
  const chartContainerRefs = useRef([]);
  const { smallTitle, handleclickExport, vmCurrentListData } = props;
  return (
    <>
      <div
        className={`${
          props.customClass ? props.customClass : "col-lg-4 col-md-6 filtercol"
        }`}
      >
        <div className="dashcol bg-white defaultCursor">
        {props.isExport && 
        <Button
          className={`text-nowrap exportbtn float-right`}
          onClick={handleclickExport}
          disabled={isEmpty(props?.selectedFiltersData?.selectedApplications) || isEmpty(vmCurrentListData)}
        >Export CSV</Button>}
          {props.customHeader ? props.customHeader() : <h4>{props.title}{smallTitle && (
                  <span style={{ fontSize : "10px" }}> {smallTitle}</span>
                )}</h4>}
          
          <div
            className={"graphblock" + (props.smallTitle ? " centerMsg" : "") + (props.title === "Compliance Findings" ? "align-items-center" : "")}
            ref={(el) => (chartContainerRefs.current[props.index] = el)}
          >
            {props.navs && <div className={`graph-des-nav ${props.navContainerClass}`}>
              <ul>
                {props.navs?.map((nav, index) => (
                  <li key={index}>
                    <span className={nav.color}>{nav?.iconText}</span>{" "}
                    {nav.text}
                  </li>
                ))}
              </ul>
            </div>}
            <div className={`chartHolder ${props.chartContainerClass}`}>
            {props?.chart?.({ ...props, chartContainerRefs, serviceFilterData: props?.moreServiceFilterData,treeChartService: props?.treeChartService, selectedServiceArray:props?.selectedServiceArray,selectedStateArray:props?.selectedStateArray,selectedRegionArray:props?.selectedRegionArray,selectedGroupArray:props?.selectedGroupArray,filterBySearch:props?.filterBySearch,atcSearchTexts:props?.atcSearchTexts,moreFilterSearch:props?.moreFilterSearch,initilaLoading:props?.initilaLoading })}
            </div>
            <div className="chart-legend-container"></div>
            {props?.axisLegend}
          </div>
        </div>
      </div>
    </>
  );
};
ChartContainer.propTypes = {
  customClass: PropTypes.string,
  smallTitle: PropTypes.bool,
  customHeader: PropTypes.func,
  title: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  navs: PropTypes.arrayOf(PropTypes.object),
  navContainerClass: PropTypes.string,
  chartContainerClass: PropTypes.string,
  chart: PropTypes.func.isRequired,
  treeChartService: PropTypes.any,
  selectedStateArray: PropTypes.array,
  selectedServiceArray: PropTypes.array,
   selectedRegionArray: PropTypes.array,
  selectedGroupArray: PropTypes.array,
  filterBySearch: PropTypes.string,
  atcSearchTexts: PropTypes.any,
  moreFilterSearch: PropTypes.any,
  initilaLoading: PropTypes.bool,
  isExport: PropTypes.bool,
  axisLegend: PropTypes.node,
  handleclickExport: PropTypes.func,
   moreServiceFilterData: PropTypes.any,
  selectedFiltersData: PropTypes.shape({
    selectedApplications: PropTypes.array,
  }),
  vmCurrentListData: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default ChartContainer;


